import React, { useMemo } from "react";

import { Executor } from "../../../../../../../../../../services";
import { useTypedSelector } from "../../../../../../../../../../redux/store";
import { CellContentRoot } from "../../../../../../../../../../components/LightTable";

const ExecutorTeamIdCellContent: React.FC<ExecutorTeamIdCellContent.Props> = ({
	item,
}) => {
	const lang = useTypedSelector((state) => state.session.language);
	const content = useMemo(
		() => item?.group?.name?.[lang] ?? "",
		[item?.group?.name, lang],
	);

	return (
		<CellContentRoot alignItems="center" w="100%" h="100%">
			{content}
		</CellContentRoot>
	);
};

declare namespace ExecutorTeamIdCellContent {
	interface Props {
		item: Executor.Model;
	}
}

export default ExecutorTeamIdCellContent;
